"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuizDoesNotExistError = void 0;
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when no quiz with a given id exists
 * @param {string} quizId
 */
class QuizDoesNotExistError extends client_library_1.ExtendableError {
    constructor(id) {
        super(`quiz: id ${id} does not exist`);
        this.id = id;
    }
}
exports.QuizDoesNotExistError = QuizDoesNotExistError;
//# sourceMappingURL=QuizDoesNotExistError.js.map